module.exports = __webpack_public_path__ + "img/logo.4806292c.png";